if (!customElements.get('floating-cta')) {
  class FloatingCta extends HTMLElement {
    connectedCallback() {
      this.showAfter = Number.parseInt(this.dataset.showAfter, 10) || 0;
      this.ticking = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.updateVisibility = this.updateVisibility.bind(this);

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      this.updateVisibility();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.updateVisibility();
        this.ticking = false;
      });
    }

    updateVisibility() {
      const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
      const shouldShow = isThemeEditor || window.scrollY >= this.showAfter;
      this.classList.toggle('is-visible', shouldShow);
    }
  }

  customElements.define('floating-cta', FloatingCta);
}
